import { updateUserRepositoryDocumentFields } from 'api/v2/users/settings';
import i18n from 'i18n';
import useMutation from 'hooks/react-query/useMutation';

import showToast from 'utils/toast';

const useUpdateUserDocumentField = () => {
  return useMutation({
    mutationFn: updateUserRepositoryDocumentFields,
    onSuccess: () => {
      showToast(
        { title: i18n.t('successfully_saved_changes') as string },
        { type: 'success' },
      );
    },
  });
};

export default useUpdateUserDocumentField;
